// extracted by mini-css-extract-plugin
export default {"faqClientAttention":"faqClientAttention_dKFwx","title":"title_meC_i","list":"list_w1_Un"};